import { useRef } from 'react';
import classes  from './ContactUsPage.module.css';
import { pageContentConstants } from '../../constants/PageContentConstants';
import '../../index.css';
import Form from '../../components/Form/GetInTouch/Form';
import contactUsImage from '../../assets/images/contact-us-latest.png';
import { Toast } from 'primereact/toast';

const ContactUsPage = () => {

    const toast = useRef(null);

    const showToast = (severity, summary, detail) => {
        toast.current.show({ severity, summary, detail, life: 3000 });
    };

    return (
        <div className={classes.container}>
            <Toast ref={toast} />
            <div className={classes.contact_image_container}>
                <div className={classes.info_container}>
                    <div className={[classes.info_container__title, "font_lg"].join(' ')}>
                        {pageContentConstants.CONTACT_US_PAGE_CONTENT.TITLE}
                    </div>
                    <div className={[classes.info_container__description, "font_md"].join(' ')}>
                        {pageContentConstants.CONTACT_US_PAGE_CONTENT.DESCRIPTION.LINE1}
                    </div>
                    <div className={[classes.info_container__description, "font_md"].join(' ')}>
                        {pageContentConstants.CONTACT_US_PAGE_CONTENT.DESCRIPTION.LINE2}
                    </div>
                    <div className={[classes.info_container__description, "font_md"].join(' ')}>
                        {pageContentConstants.CONTACT_US_PAGE_CONTENT.DESCRIPTION.LINE3}
                    </div>
                </div>
                <img src={contactUsImage} alt="contact-us"></img>
            </div>
            <div className={classes.contact_form_container}>
                <Form showToast={showToast} service="General query from contact us page"/>
            </div>
        </div>
    )
}

export default ContactUsPage;